import $ from 'jquery';
import { axiosInstance as axios, handleAxiosErrors } from '../_utils';
import config from '../store/_config';
import { convertUserDetailedInformationToAReadableFormat } from '../selectors/converterSelector';
import { setAddressList } from './addressActions';
import { createAlert } from '../dom/window';
import { getTranslation } from '../lang/main';
import { axiosRequestAddresses, requestDispatchLocations } from './user/address';
import { axiousRequestPostmenListing } from './user/postmen';
import { axiousRequestCartRuleListing } from './user/cartRule';
import { handleStripeWarning, requestPayFastMissingFields, requestStripeMissingFields } from './user/stripe';

export const toggleLoading = (key, value, orderOnBehalfOf = false) => {
    if (orderOnBehalfOf) {
        return {
            type: 'TOGGLE_PURCHASING_USER_LOADING',
            key: key,
            value: value,
        };
    }

    return {
        type: 'TOGGLE_USER_LOADING',
        key: key,
        value: value,
    };
};
export const setInitialized = (value, orderOnBehalfOf = false) => {
    if (orderOnBehalfOf) {
        return {
            type: 'SET_PURCHASING_USER_INITIALIZED',
            value: value,
        };
    }

    return {
        type: 'SET_USER_INITIALIZED',
        value: value,
    };
};
export const setMemberType = (value, orderOnBehalfOf = false) => {
    if (orderOnBehalfOf) {
        return {
            type: 'SET_PURCHASING_USER_MEMBER_TYPE',
            value: value,
        };
    }

    return {
        type: 'SET_MEMBER_TYPE',
        value: value,
    };
};
export const setMemberProductConfiguratorType = (value) => {
    return {
        type: 'SET_MEMBER_PRODUCT_CONFIGURATOR_TYPE',
        value: value,
    };
};
export const setLoggedIn = (value) => {
    return {
        type: 'SET_LOGGED_IN',
        value: value,
    };
};
export const setReAuth = (value) => {
    return {
        type: 'SET_RE_AUTH',
        value: value,
    };
};
export const setConversionRate = (value) => {
    return {
        type: 'SET_CONVERSION_RATE',
        value: value,
    };
};
export const setOrderOnBehalf = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SET_ORDER_ON_BEHALF',
            value: value,
        });

        if (value === true) {
            const store = getState();
            const memberType = store.user.type;
            let orderOnBehalfMemberType = '';

            switch (memberType) {
                case 'wholesaler':
                    orderOnBehalfMemberType = 'reseller';
                    break;

                case 'reseller': case 'parent-reseller':
                    orderOnBehalfMemberType = 'retail-customer';
                    break;

            }

            if (orderOnBehalfMemberType) {
                dispatch(setMemberType(orderOnBehalfMemberType, true));
            }
        }

    };
};
export const setUserInfo = (value, orderOnBehalfOf = false) => {
    return (dispatch) => {
        if (typeof value.availableAddresses != 'undefined') {
            dispatch(setAddressList(value.availableAddresses));
            value.availableAddresses = value.availableAddresses.map(
                (item) => item.ID
            );
        }

        if (orderOnBehalfOf) {
            dispatch({
                type: 'SET_PURCHASING_USER_INFO',
                value: value,
            });
        } else {
            dispatch({
                type: 'SET_USER_INFO',
                value: value,
            });
        }

        dispatch(handleStripeWarning());
    };
};
export const setSupplierInfo = (id, value) => {
    return {
        type: 'SET_SUPPLIER_INFO',
        id: id,
        value: value,
    };
};
export const requestPurchasingUserInfo = (offset = 0, limit = 5, search = '', type = 'basic') => {
    return (dispatch, getState) => {
        const store = getState();

        if (store.user.orderOnBehalf === true) {
            return dispatch(requestInfo(offset, limit, search, type, true));
        } else {
            return dispatch(requestInfo(offset, limit, search, type));
        }

    };
};

export const requestDisPatchLocationFilter = (limit = 5, search = '', type = 'basic') => {
    return (dispatch, getState) => {
        dispatch(toggleLoading('dispatchLocationList', true));
        const store = getState();
        return dispatch(requestDispatchLocations(limit, search));
    };
};


export const requestInfo = (offset = 0, limit = 5, search = '', type = 'basic', orderOnBehalfOf = false, isAccountPage = false) => {

    return (dispatch, getState) => {
        const state = getState();

        if (state.user.loggedIn) {
            const axiosRequest =
                type == 'basic'
                    ? () => axiosRequestBasicInfo(offset, limit, search, orderOnBehalfOf)
                    : () => axiosRequestDetailedUserInfo(offset, limit, search, orderOnBehalfOf);


            dispatch(toggleLoading('basicInfo', true, orderOnBehalfOf));

            return axiosRequest(orderOnBehalfOf)
                .then((resRequest) => {
                    return axiousRequestPostmenListing()
                        .then(async (resPostmenListing) => {

                            const userInfo = convertUserDetailedInformationToAReadableFormat({
                                ...resRequest.data.data.readOneMember,
                                Postmen: resPostmenListing.data.data.readMemberPostmenShippingAccounts,
                            });

                            dispatch(setUserInfo(userInfo, orderOnBehalfOf));

                            if (resRequest.data.data.readOneMember && typeof (resRequest.data.data.readOneMember.PriceConversionRate) != 'undefined') {
                                dispatch(setConversionRate(resRequest.data.data.readOneMember.PriceConversionRate || 0));
                            }

                            if (!orderOnBehalfOf) {
                                dispatch(checkUserSupplier());

                                if (userInfo.selectedParentID) {
                                    dispatch(
                                        requestSupplierAddresses(
                                            userInfo.selectedParentID
                                        )
                                    );
                                }
                            }

                            dispatch(setInitialized(true, orderOnBehalfOf));
                            dispatch(
                                toggleLoading(
                                    'basicInfo',
                                    false,
                                    orderOnBehalfOf
                                )
                            );
                        })
                        .catch((error) => {
                            handleAxiosErrors(error);
                            dispatch(toggleLoading('basicInfo', false));
                        });
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                    dispatch(toggleLoading('basicInfo', false));
                });
        }
    };
};


export const requestInfoAccountDetail = (offset = 0, limit = 5, search = '', type = 'basic', orderOnBehalfOf = false, isAccountPage = true) => {
    return (dispatch, getState) => {
        console.log('isAccountPage', isAccountPage);
        const state = getState();
        if (state.user.loggedIn) {
            const axiosRequest =
                type == 'basic'
                    ? () => axiosRequestBasicInfo(offset, limit, search, orderOnBehalfOf, isAccountPage)
                    : () => axiosRequestDetailedUserInfo(offset, limit, search, orderOnBehalfOf, isAccountPage);
            dispatch(toggleLoading('basicInfo', true, orderOnBehalfOf));
            return axiosRequest(orderOnBehalfOf)
                .then((resRequest) => {
                    return axiousRequestPostmenListing()
                        .then(async (resPostmenListing) => {

                            const userInfo = convertUserDetailedInformationToAReadableFormat({
                                ...resRequest.data.data.readOneMember,
                                Postmen: resPostmenListing.data.data.readMemberPostmenShippingAccounts,
                            });

                            dispatch(setUserInfo(userInfo, orderOnBehalfOf));

                            if (resRequest.data.data.readOneMember && typeof (resRequest.data.data.readOneMember.PriceConversionRate) != 'undefined') {
                                dispatch(setConversionRate(resRequest.data.data.readOneMember.PriceConversionRate || 0));
                            }

                            if (!orderOnBehalfOf) {
                                dispatch(checkUserSupplier());

                                if (userInfo.selectedParentID) {
                                    dispatch(
                                        requestSupplierAddresses(
                                            userInfo.selectedParentID
                                        )
                                    );
                                }
                            }

                            dispatch(setInitialized(true, orderOnBehalfOf));
                            dispatch(
                                toggleLoading(
                                    'basicInfo',
                                    false,
                                    orderOnBehalfOf
                                )
                            );
                        })
                        .catch((error) => {
                            handleAxiosErrors(error);
                            dispatch(toggleLoading('basicInfo', false));
                        });
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                    dispatch(toggleLoading('basicInfo', false));
                });
        }
    };
};


export const requestUserStripeInfo = (orderOnBehalfOf = false) => {
    return (dispatch, getState) => {
        const state = getState();
        const fields = Object.keys(state.user.stripeFieldData);

        if (state.user.loggedIn) {
            dispatch(toggleLoading('basicInfo', true, orderOnBehalfOf));

            return axiosRequestUserStripeInfo(fields, orderOnBehalfOf)
                .then((resRequest) => {
                    const userInfo = {
                        basicInfo: resRequest.data.data.readOneMember
                    };

                    dispatch(setUserInfo(userInfo, orderOnBehalfOf));
                    dispatch(toggleLoading('basicInfo', false, orderOnBehalfOf));
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                    dispatch(toggleLoading('basicInfo', false));
                });
        }
    };
};
export const requestSupplierAddresses = (id) => {
    return (dispatch, getState) => {
        if (id > 0) {
            dispatch(toggleLoading('supplierAddresses', true));

            return axiosRequestAddresses(id)
                .then((response) => {
                    const userInfo = convertUserDetailedInformationToAReadableFormat(
                        response.data.data.readOneMember
                    );

                    // const list = userInfo.availableAddresses;
                    const list = [];

                    if (userInfo.businessAddress.ID > 0) {
                        list.push(userInfo.businessAddress);
                    }

                    if (list) {
                        let updatedInfo = {
                            Addresses: [userInfo.businessAddress.ID],
                            // Addresses: list.map((item) => item.ID),
                            DeliveryAddressID: userInfo.businessAddress.ID,
                        };

                        if (
                            typeof userInfo.defaultDeliveryAddressID != 'undefined'
                        ) {
                            // updatedInfo.DeliveryAddressID = userInfo.defaultDeliveryAddressID;
                            updatedInfo.DeliveryAddressID = userInfo.businessAddress.ID;
                        }

                        dispatch(setAddressList(list));
                        dispatch(setSupplierInfo(id, updatedInfo));
                    }

                    dispatch(toggleLoading('supplierAddresses', false));
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                    dispatch(toggleLoading('supplierAddresses', false));
                });
        }
    };
};
export const saveConversionRate = () => {
    return (dispatch, getState) => {
        const state = getState();
        const { conversionRate } = state.user;

        const formData = {
            PriceConversionRate: Number(conversionRate) || 0
        };

        dispatch(toggleLoading('conversionRate', true));

        return axiosUpdateAccountHolderInformation(formData)
            .then((response) => {
                if (typeof (response.data.data.updateMemberInfo.PriceConversionRate) != 'undefined') {
                    dispatch(setConversionRate(response.data.data.updateMemberInfo.PriceConversionRate || 0));
                }
            })
            .catch((response) => {
                handleAxiosErrors(response);
            })
            .then(() => {
                dispatch(toggleLoading('conversionRate', false));
            });
    };
};

/**
 * Main function to update user data
 * Some information that can be updated includes:
 *  User Info
 *  Default Delivery Address ID
 *
 * @param formData
 * @param callback
 */
export const submitAccountHolderInformation = (formData, callback) => {
    return (dispatch) => {
        const successCallback = typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback = typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback = typeof callback.always != 'undefined' ? callback.always : null;

        const successMessage = formData?.ConfirmEmail != undefined ? getTranslation('ACCOUNT_HOLDER_INFORMATION_FORM.SUCCESS_MESSAGE') : getTranslation('ACCOUNT_HOLDER_INFORMATION_FORM.SUCCESS_MESSAGE');

        return axiosUpdateAccountHolderInformation(formData)
            .then((response) => {
                const userInfo = convertUserDetailedInformationToAReadableFormat(
                    response.data.data.updateMemberInfo
                );
                dispatch(setUserInfo(userInfo));

                if (typeof (response.data.data.updateMemberInfo.PriceConversionRate) != 'undefined') {
                    dispatch(setConversionRate(response.data.data.updateMemberInfo.PriceConversionRate || 0));
                }

                createAlert({
                    message: window.isGuestUser ? 'Your account has been created successfully! You can now continue with your order. Don’t forget to save your login details for future use.' : successMessage,
                }, 'success');

                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };
};

export const submitReAuthPasswordInformation = (formData, callback) => {
    return (dispatch, getState) => {
        const successCallback = typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback = typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback = typeof callback.always != 'undefined' ? callback.always : null;
        const state = getState();
        const userReAuth = state.user.isReAuth;
        const successMessage = formData?.Password != undefined ? getTranslation('ACCOUNT_HOLDER_INFORMATION_FORM.SUCCESS_MESSAGE_EMAIL') : getTranslation('ACCOUNT_HOLDER_INFORMATION_FORM.SUCCESS_MESSAGE');
        if (formData?.Password === 'LPUS@1022') {
            if (successCallback) successCallback(successMessage);
            if (alwaysCallback) alwaysCallback(successMessage);
            $('#re-authenticate-password').modal('hide');
            if (userReAuth) {
                dispatch(setReAuth(false))
            }
            else {
                dispatch(setReAuth(true))
            }
        }
        else {
            if (errorCallback) errorCallback(successMessage);
            if (alwaysCallback) alwaysCallback(successMessage);
            createAlert({
                message: 'Please Enter Correct Password',
            }, 'error');
        }

    };
};

/**
 * Main function to update user data
 * Some information that can be updated includes:
 *  User Info
 *  Default Delivery Address ID
 *
 * @param formData
 * @param callback
 */
export const submitStripeInformation = (formData, callback) => {
    return (dispatch) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        return axiosUpdateStripeInfo(formData)
            .then((response) => {
                createAlert(
                    {
                        message: getTranslation(
                            'ACCOUNT_HOLDER_INFORMATION_FORM.SUCCESS_MESSAGE'
                        ),
                    },
                    'success'
                );

                // Re-request the info
                dispatch(requestStripeMissingFields());

                // Update ribbon
                const data = response.data.data.validateStripeConnectAccount || {};
                if (data.RequirementDue == false) {
                    $('#stripe-warning').slideUp();
                }

                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };
};

export const submitPayFastInformation = (formData, callback) => {
    return (dispatch) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        return axiosUpdatePayFastInfo(formData)
            .then((response) => {
                createAlert(
                    {
                        message: getTranslation(
                            'ACCOUNT_HOLDER_INFORMATION_FORM.SUCCESS_MESSAGE'
                        ),
                    },
                    'success'
                );

                // Re-request the info
                dispatch(requestPayFastMissingFields());

                // Update ribbon
                const data = response.data.data.validatePayFastAccount || {};
                if (data.RequirementDue == false) {
                    $('#stripe-warning').slideUp();
                }

                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };
};

export const axiosRequestFilteredSuppliers = (addressID) => {
    let { url, query } = config.user.filteredSuppliers;

    query = query.replace(/{AddressID}/, addressID);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosRequestBasicInfo = (offset = 0, limit = 5, search = '', orderOnBehalfOf = false, isAccountPage = false) => {
    let { url, query } = config.user.basicInfo;
    console.log('orderOnBehalfOf', orderOnBehalfOf);
    if (orderOnBehalfOf === true) {
        // query = query.replace(
        //     'readOneMember',
        //     `readOneMember(PurchasingUser: true)`
        // );
    }
    let variables = {
        limit: isAccountPage ? 9999 : limit,
        search: search,
    };
    if (orderOnBehalfOf === true) {
        variables.PurchasingUser = true;
    }

    return axios.post(url, {
        withCredentials: true,
        variables: variables,
        query: query,

    });
};
export const axiosRequestDetailedUserInfo = (offset = 1, limit = 9999, search = '', orderOnBehalfOf = false, isAccountPage = false) => {
    let { url, query } = config.user.detailedInfo;
    // if (orderOnBehalfOf === true) {
    //     query = query.replace(
    //         'readOneMember',
    //         `readOneMember(PurchasingUser: true)`
    //     );
    // }
    let variables = {
        limit: isAccountPage ? 9999 : limit,
        search: search,
    };
    if (orderOnBehalfOf === true) {
        variables.PurchasingUser = true;
    }


    return axios.post(url, {
        withCredentials: true,
        variables: variables,
        query: query,
        // params: {
        //     query: query,

        // },
    });
};

export const axiosRequestUserStripeInfo = (fields = [], orderOnBehalfOf = false) => {
    let { url, query } = config.user.stripeInfo;
    query = query.replace('{fields}', fields.join(' '));

    if (orderOnBehalfOf === true) {
        query = query.replace('readOneMember', 'readOneMember(PurchasingUser: true)');
    }

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const axiosVerifyAccessCode = (accessCode) => {
    let { url, query } = config.user.verifyAccessCode;

    let data = {
        query: query,
        variables: {
            accessCode: accessCode
        },
    };

    return axios.post(url, data, {
        withCredentials: true
    });
};

export const axiosRequestPreferredSuppliers = () => {
    let { url, query } = config.user.preferredSupplier;

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosUpdateAccountHolderInformation = (
    formData,
    memberID = null
) => {
    let { url, query } = config.user.updateDetails;

    const ignoredKeys = [
        'ID',
        'ReferralCoupon',
        'CreateSubStoreAccessCode',
        'showMoreFields',
        'IsStripeConnectComplete',
        'IsStripeConnectRequired',
        'IsStripeConnectExternalAccountDue',
        'IsStripeConnectOtherRequirementDue',
    ];

    ignoredKeys.forEach((ignoredKey) => {
        if (typeof formData[ignoredKey] != 'undefined') {
            delete formData[ignoredKey];
        }
    });

    if (formData.IsGuestUser != undefined) {
        formData.IsGuestUser = !!(formData.IsGuestUser + 1 - 1)
    }

    // Only send Email if EmailConfirmation exists
    if (formData.ConfirmEmail === undefined) {
        delete formData.Email;
    }

    let data = {
        id: query,
        variables: {
            Input: formData,
        },
    };

    if (memberID != null) {
        data.variables.MemberID = memberID;
    }

    return axios.post(url, data, {
        withCredentials: true,
    });
};
export const axiosUpdateStripeInfo = (formData, memberID = null) => {
    let { url, query } = config.user.updateStripeDetails;

    // Update this
    const ignoredKeys = [
        'ID',
        'Email',
        'EmailConfirmation',
        'ReferralCoupon',
        'showMoreFields',
        'showMoreFields',
    ];

    ignoredKeys.forEach((ignoredKey) => {
        if (typeof formData[ignoredKey] != 'undefined') {
            delete formData[ignoredKey];
        }
    });

    let data = {
        id: query,
        variables: {
            Input: formData,
        },
    };

    if (memberID != null) {
        data.variables.MemberID = memberID;
    }

    return axios.post(url, data, {
        withCredentials: true,
    });
};

export const axiosUpdatePayFastInfo = (formData, memberID = null) => {
    let { url, query } = config.user.updatePayFastDetails;

    // Update this
    const ignoredKeys = [
        'ID',
        'Email',
        'EmailConfirmation',
        'ReferralCoupon',
        'showMoreFields',
        'showMoreFields',
    ];

    ignoredKeys.forEach((ignoredKey) => {
        if (typeof formData[ignoredKey] != 'undefined') {
            delete formData[ignoredKey];
        }
    });

    let data = {
        id: query,
        variables: {
            Input: formData,
        },
    };

    if (memberID != null) {
        data.variables.MemberID = memberID;
    }

    return axios.post(url, data, {
        withCredentials: true,
    });
};

export const axiosUpdateSelectedSupplierInformation = (formData) => {
    let { url, query } = config.user.updateSelectedSupplierInfo;

    let data = {
        id: query,
        variables: {
            Input: formData,
        },
    };

    return axios.post(url, data, {
        withCredentials: true,
    });
};
export const axiosDeletePreferredSupplier = (ids) => {
    let { url, query } = config.user.deletePreferredSupplier;

    let data = {
        id: query,
        variables: {
            IDs: ids,
        },
    };

    return axios.post(url, data, {
        withCredentials: true,
    });
};
export const showChangeAddressModal = () => {
    $('#select-delivery-supplier-modal').modal('show');
};
export const checkUserSupplier = () => {
    return (dispatch, getState) => {
        const state = getState();

        if (
            typeof state.user.info.ParentID != 'undefined' &&
            state.user.info.ParentID == 0
        ) {
            showChangeAddressModal();
        } else if (
            typeof state.user.info.DeliveryAddressID != 'undefined' &&
            state.user.info.DeliveryAddressID == 0
        ) {
            showChangeAddressModal();
        }
    };
};
export const handleSignInToOrder = (e) => {
    e.preventDefault();

    const $signInButton = $('#sign-in-button');
    if ($signInButton.is(':visible')) {
        $signInButton.trigger('click');
    } else {
        if (typeof window.loginLink != 'undefined') {
            window.location.href = window.loginLink;
        }
    }
};
